import React from 'react';
import { Marker } from 'react-google-maps';

const Markers = ({ data = [] }) => {
  return data.map(({ lat, lng }) => {
    return <Marker key={`${lat}_${lng}`} position={{ lat, lng }} />;
  });
};

export default Markers;



// WEBPACK FOOTER //
// ./src/Components/Map/Markers.js